import React from "react"
import { AcademyButton, TopContainer } from "./ViewOrder.styled"
import { GoBackLink } from "../../../components/Ui/Page/PageHeader.styled"
import { ReactComponent as ArrowLeft } from "images/icons/arrow-left.svg"
import { ReactComponent as AcademyIcon } from "images/icons/graduation-cap.svg"
import Box from "../../../components/Ui/Box"

const ViewOrderError = () => {
  return (
    <Box padding="0" margin="0">
      <TopContainer>
        <GoBackLink to={"/orders"}>
          <ArrowLeft /> Back to orders
        </GoBackLink>
        <AcademyButton
          href={"https://brinkcommerce.featurebase.app/help/collections/6272544-orders"}
          target={"_blank"}
        >
          <AcademyIcon />
        </AcademyButton>
      </TopContainer>
    </Box>
  )
}

export default ViewOrderError
